import React from "react";

import "../css/education.css";

const Education = () => {
    return (
        <div className="education-container">
            <div className="education-sub-container ">
                <div className="undergrad-container">
                    <h2 className="education-title">Bachelors of Science: Computer Science</h2>
                    <h3 className="education-progress">Graduate Honors: Summa Cum Laude</h3>
                    <p className="education-description">
                        During my undergraduate studies at Oregon State University, I earned a Bachelor of Science in Computer Science and
                        built a strong foundation in both theory and hands-on development. I worked with C++, Python, JavaScript, SQL, and
                        frameworks such as React.js, Node.js, and Flutter, along with AWS, Google Cloud, Git/GitHub, and Docker. My interest
                        in systems and security led me to use Linux environments like Rocky 8 and Kali Linux, strengthening my understanding
                        of operating systems and scripting. Through team projects and independent work, I gained confidence solving complex
                        problems and writing efficient, maintainable code. My undergraduate experience shaped how I approach software from
                        architecture and design to deployment and helped me develop a passion for building functional, user-focused tools.
                    </p>
                    <h2 className="notable-courses-title">Notable Courses</h2>

                    <div className="notable-courses">
                        <h2>Analysis of Algorithms</h2>
                        <h2>Operating Systems</h2>
                        <h2>Database Management Systems</h2>
                        <h2>Software Engineering</h2>
                        <h2>Mobile Development</h2>
                        <h2>Cloud Development</h2>
                    </div>
                </div>

                <div className="grad-container">
                    <h2 className="education-title">Masters of Engineering: Computer Science</h2>
                    <h3 className="education-progress">In Progress</h3>

                    <p className="education-description">
                        As a graduate student in the Computer Science program at Oregon State University, I've focused on building advanced
                        skills in areas such as software design, data analysis, and system optimization. The program has emphasized
                        project-based learning, encouraging me to apply theory to practical, real-world challenges while exploring topics at
                        a deeper level than in undergrad. I've had the opportunity to work with modern development tools and frameworks,
                        collaborate on technical teams, and strengthen both my problem-solving and research abilities. Through this
                        experience, I've become more confident in designing scalable systems, writing efficient code, and thinking
                        critically about how technology can be used to solve complex problems. OSU's supportive and intellectually engaging
                        environment has helped me grow not just as a developer but as a thinker and communicator, ready to take on technical
                        challenges in both industry and research settings.
                    </p>
                    <h2 className="notable-courses-title">Notable Courses</h2>
                    <div className="notable-courses">
                        <h2>Machine Learning</h2>
                        <h2>AI: Agents, Search Reasoning</h2>
                        <h2>Database Management Systems</h2>
                        <h2>Advance Networking</h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Education;
